import {
  Box,
  Button,
  FormHelperText,
  InputAdornment,
  Modal,
  OutlinedInput,
  Slider,
  TextField,
} from '@mui/material'
import React, { useState } from 'react'
import AddOrEditSkillsModal from './AddOrEditSkillsModal'
import '../styles.scss'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const DistanceFilterDropdownModal = ({
  distanceFilterModal = false,
  handleDistanceFilterDropdownModal,
  distanceDropdownValue,
  setDistanceDropdownValue,
}) => {
  const handleDistanceDropdownValueChange = (event, newValue) => {
    setDistanceDropdownValue(newValue)
  }

  return (
    <div>
      <Modal
        open={distanceFilterModal}
        onClose={() => handleDistanceFilterDropdownModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="set-skill-rate-modal">
          <div>
            <Slider
              size="small"
              defaultValue={10}
              aria-label="Small"
              valueLabelDisplay="auto"
              onChange={handleDistanceDropdownValueChange}
            />
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <p className="fs-18 fw-bold">{distanceDropdownValue} miles</p>
            <button
              id="serviceBtn"
              className="commonBtn serviceCardBtn"
              onClick={() => handleDistanceFilterDropdownModal(false)}
            >
              Done
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  )
}

export default DistanceFilterDropdownModal
